import {
  Archive,
  KeyboardArrowDown,
  KeyboardArrowRight,
  MoreVert,
  Search,
  HelpOutline,
} from "@material-ui/icons";
import React from "react";
import {
  Button,
  Col,
  Collapse,
  Dropdown,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import { connect } from "react-redux";
import {
  addDocAction,
  listDocAction,
  removeDocAction,
  updateDocAction,
  uploadDocumentAction,
  getFolderPermissionAction,
  setFolderPermissionAction,
} from "./../../actions/DocActions";
import folderIcon from "./../../assets/img/folder.svg";
import DocumentsDetail from "./DocumentsDetail";
import { cryptoTokenDecode, toastMessage } from "./../Common/Common";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";

var _ = require("lodash");

class Documents extends React.Component {
  constructor(props) {
    // let currentType = localStorage.getItem("currentRole");
    let currentType = cryptoTokenDecode().roleName;
    let userType = cryptoTokenDecode().usertype;
    super(props);
    this.state = {
      showArchieve: true,
      show: false,
      OpenDocumentDetail: false,
      folders: [],
      originalFolders: {},
      archiveFolders: [],
      originalArchive: {},
      folderName: "",
      selectedFolderName: "",
      showLoader: false,
      renameFolder: false,
      documents: [],
      searchParam: "",
      userType: userType.toUpperCase(),
      folderExists: false,
      userRole: !!currentType ? currentType.toUpperCase() : "",
      showPermissionModal: false,
      permissionDetail: [],
      folderNameList: [],
      selectAll: false,
      canAddDoc: false,
      canArchive: false,
      canMoveDoc: false,
      archiveList: [],
      showArchiveModal: false,
      archiveName: "",
      viewDisabled: false,
    };
  }

  showArchieve() {
    this.setState({ showArchieve: !this.state.showArchieve });
  }

  /**
   * Desc open modal for create folder or rename folder
   * @param {*} rename
   */
  setModalOpen(rename) {
    if (rename) {
      this.setState({
        folderName: rename,
        renameFolder: true,
        searchParam: "",
      });
    } else {
      this.setState({ folderName: "", renameFolder: false });
    }
    this.setState({ show: !this.state.show });
  }
  /**
   * @desc open document details on modal view
   */
  OpenDocumentDetail() {
    if (window.innerWidth < 768) {
      this.setState({
        OpenDocumentDetail: !this.state.OpenDocumentDetail,
      });
    }
  }

  componentDidMount() {
    this.getAllFolders(0, "first");
  }

  showLoader(visible) {
    this.setState({ showLoader: visible });
  }
  /**
   * @desc get all documents and arrange it folderwise
   * @param {*} index
   * @param {*} type
   */
  getAllFolders(index, type) {
    this.showLoader(true);
    this.props.listDocAction(this.props.transactionId, "active").then((res) => {
      var folders = [];
      if (res.length > 0) {
        res.sort().map((res) => {
          if (res.canView) {
            folders.push(res);
          }
        });

        folders.forEach((element) => {
          element.isChecked = false;
        });
        this.setState({ folders, originalFolders: folders }, () => {
          this.showLoader(false);
          if (type === "add" && index == "Archived Docs") {
            this.selectFolder(index, true);
          } else if (type === "fromArchive") {
            this.selectFolder("Archived Docs", true);
          } else if (type === "archive" || type === "add") {
            this.selectFolder(index);
          } else if (type === "first") {
            if (this.state.userType === message.ACCTOWNER) {
              this.setState({
                canAddDoc: true,
                canArchive: true,
                canMoveDoc: true,
              });
              this.selectFolder("Transaction Docs", false, true);
            } else {
              if (folders.length > 0) {
                if (
                  folders.some((item) => item.location === "Transaction Docs")
                ) {
                  this.selectFolder("Transaction Docs", false, true);
                } else {
                  this.selectFolder(folders[0].location, false, true);
                }
                this.setState({
                  canAddDoc: folders[0].canAdd,
                  canArchive: folders[0].canDelete,
                  canMoveDoc: folders[0].canMove,
                });
              }
            }
          }
        });
      }
    });
    this.setState({ folderNameList: [], selectAll: false });
    if (
      this.state.userType !== message.BUYER ||
      this.state.userType === message.ACCTOWNER ||
      (this.state.userType === message.VENDOR &&
        this.state.userRole === message.Artist)
    ) {
      this.props
        .listDocAction(this.props.transactionId, "archive")
        .then((res) => {
          var archiveFolders = [];
          if (res) {
            res.sort().map((res) => {
              if (res.canView) {
                archiveFolders.push(res);
              }
            });

            this.setState(
              { archiveFolders, originalArchive: archiveFolders },
              () => {
                this.showLoader(false);
              }
            );
          }
        });
    }
  }

  createNewFolder(name) {
    name = (name + "").trim();

    this.setState({ folderExists: false });
    if (name.includes(",")) {
      toastMessage(code.ERROR, message.ENTER_VALID_FOLDER_NAME);
    } else {
      this.showLoader(true);
      var dataToPost = {
        transactionId: this.props.transactionId,
        location: name,
        document: [],
      };
      if (this.state.renameFolder) {
        var data = {
          TransactionId: this.props.transactionId,
          location: this.state.selectedFolderName,
          newLocation: name,
          isDelete: false,
        };
        this.props.removeDocAction(data).then((res) => {
          if (res.status === code.OK) {
            this.getAllFolders(name, "add");
            this.setModalOpen();
            this.showLoader(false);
          } else {
            this.setModalOpen();
            this.showLoader(false);
            toastMessage(code.ERROR, res.data);
          }
        });
        this.setState({ renameFolder: false });
      } else {
        this.props.addDocAction(dataToPost).then((res) => {
          this.showLoader(false);
          if (res && res.status === code.CONFLICT) {
            toastMessage(code.ERROR, res.data);
            this.setModalOpen();
          } else {
            this.getAllFolders(name, "add");
            this.setState({ folderExists: false });
            this.setModalOpen();
          }
        });
      }
    }
  }

  /**
   * @desc archive folder by name and refresh list of folder
   * @param {*} name
   */
  archiveFolder(name) {
    var dataToPost = {
      TransactionId: this.props.transactionId,
      location: name,
      newLocation: name,
      isDelete: true,
    };
    this.props.removeDocAction(dataToPost).then((res) => {
      this.setState({ showArchiveModal: false });
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, message.FOLDER_ARCHIVED);
        this.getAllFolders(name, "first");
        this.showLoader(false);
      } else {
        toastMessage(code.ERROR, res.data);
        this.showLoader(false);
      }
    });
  }

  /**
   * @desc action on selecting folder and loading documents within folder
   * @param {*} name
   * @param {*} hideNewDocument
   * @param {*} isFirst
   */
  selectFolder(name, hideNewDocument, isFirst) {
    var documents = [];
    var id = "";
    if (hideNewDocument) {
      if (name === "Archived Docs") {
        this.state.folders.map((e) => {
          documents = _.concat(
            documents,
            (e.documents || []).filter((item) => {
              return item.isArchive === true;
            })
          );
        });
        this.state.archiveFolders.map((e) => {
          documents = _.concat(
            documents,
            (e.documents || []).filter((item) => {
              return item.isArchive === true;
            })
          );
        });
      } else {
        this.state.archiveFolders.map((e) => {
          if (e.location === name) {
            documents = (e.documents || []).filter((item) => {
              return item.isDelete === true && item.isArchive === false;
            });
          }
        });
      }
    } else {
      this.state.folders.map((e) => {
        if (e.location === name && e.isDelete === false) {
          documents = (e.documents || []).filter((item) => {
            return item.isDelete === false && item.isArchive === false;
          });
        }
      });
    }
    _.remove(documents, (e) => {
      return e.document === undefined || e.document === "";
    });

    if (!isFirst) {
      this.OpenDocumentDetail();
    }
    this.setState({
      selectedFolderName: name,
      folderId: id || "",
      documents,
      hideNewDocument,
    });
  }
  /**
   * @desc upload new document
   * sending form data with js FormData object as its multipart data (file objects)
   * @param {*} files
   */
  uploadNewDocument(files) {
    var documents = [];
    var docDetail = {};
    this.showLoader(true);
    if (files.length > 0) {
      var formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        docDetail = {
          fileName: files[i].name,
          size: (files[i].size / (1024 * 1024)).toFixed(2),
        };
        documents.push(docDetail);
        formData.append("file", files[i]);
      }

      var dataToPost = {
        transactionId: this.props.transactionId,
        location: this.state.selectedFolderName,
        document: documents,
      };
      this.showLoader(true);
      this.props.addDocAction(dataToPost).then((res) => {
        this.showLoader(false);
        if (res.status === code.OK) {
          this.showLoader(true);
          var fileUploadName = "";
          res.data.map((item) => {
            // console.log('uploadNewDocument item: ', item);
            if (fileUploadName.length > 0) {
              fileUploadName +=
                "@@@" + item.document + "###" + item.uploadedFileName;
            } else {
              fileUploadName = item.document + "###" + item.uploadedFileName;
            }
          });
          //api call for upload doc
          this.props
            .uploadDocumentAction(
              formData,
              this.props.transactionId,
              undefined,
              fileUploadName
            )
            .then((isValidDoc) => {
              this.showLoader(false);
              if (isValidDoc) {
                this.getAllFolders(this.state.selectedFolderName, "add");
              }
            });
        } else {
          toastMessage(code.ERROR, res.data);
        }
      });
    } else {
      this.showLoader(false);
    }
  }
  /**
   * @desc api call for get permission folder wise
   * @param {*} folderName
   */
  getFolderPermission(folderName) {
    this.props
      .getFolderPermissionAction(this.props.transactionId, folderName)
      .then((res) => {
        if (res.status === code.OK) {
          this.setState({ permissionDetail: res.data });
        }
      });
  }
  /**
   * @desc give search result with document and folder name
   * @param {*} name
   */
  searchDocumentByName(name) {
    var folders = this.state.originalFolders;
    var archiveFolder = this.state.originalArchive;
    var filteredFolders = [];
    var filterArchive = [];
    if (name !== "") {
      filteredFolders = folders.filter((o) => {
        var found = false;
        Object.keys(o).forEach((v) => {
          if (v == "location") {
            let item = o[v] + "";
            if (item.toLowerCase().includes(name.toLowerCase())) {
              found = true;
            }
          } else if (v == "documents") {
            o.documents.filter((item) => {
              let document = item.document + "";
              if (document.toLowerCase().includes(name.toLowerCase())) {
                found = true;
              }
            });
          }
        });
        return found;
      });
      if (Object.keys(archiveFolder).length !== 0) {
        filterArchive = archiveFolder.filter((o) => {
          var found = false;
          Object.keys(o).forEach((v) => {
            if (v == "location") {
              let item = o[v] + "";
              if (item.toLowerCase().includes(name.toLowerCase())) {
                found = true;
              }
            } else if (v == "documents") {
              o.documents.filter((item) => {
                let document = item.document + "";
                if (document.toLowerCase().includes(name.toLowerCase())) {
                  found = true;
                }
              });
            }
          });
          return found;
        });
      }
    } else {
      filteredFolders = folders;
      filterArchive = archiveFolder;
    }
    this.setState(
      {
        folders: filteredFolders,
        searchParam: name,
        archiveFolders: filterArchive,
      },
      () => {
        if (this.state.folders.length > 0) {
          this.selectFolder(
            name.length > 0
              ? this.state.folders[0].location
              : "Transaction Docs"
          );
        } else {
          this.selectFolder("");
        }
      }
    );
  }

  refreshDocuments(res) {
    this.getAllFolders(this.state.selectedFolderName, res);
  }
  setPermissionModal() {
    this.state.folders.map((item) => {
      if (item.isChecked) {
        item.isChecked = false;
      }
    });
    this.setState({
      showPermissionModal: !this.state.showPermissionModal,
      folderName: "",
      folderNameList: [],
      selectAll: false,
    });
  }

  /**
   * @desc set changed permission to state
   * @param {*} uId
   * @param {*} field
   * @param {*} permissionVal
   */
  setPermissionData(uId, field, permissionVal) {
    // passed uId (user), field (permission name), permissionVal (value of checkbox control)
    // fires when permission checkbox is checked/unchecked
    // given params are pushed to permissionDetail array and set in state
    // updates permission booleans (canView, canAdd, canMove, canDelete) on change

    var permissionDetail = [];
    this.state.permissionDetail.filter((permissionList) => {
      if (permissionList.userId === uId) {
        if (field === "view") {
          permissionList.canView = permissionVal.target.checked;
        } else if (field === "add") {
          permissionList.canAdd = permissionVal.target.checked;
        } else if (field === "move") {
          permissionList.canMove = permissionVal.target.checked;
        } else {
          permissionList.canDelete = permissionVal.target.checked;
        }
      }
      permissionDetail.push(permissionList);
    });
    this.setState({ permissionDetail });
  }
  /**
   * @desc api call for set permission
   */
  setUserPermission() {
    // fires when "Okay" button is clicked once permissions are chosen to grant
    // passes transactionId (which transaction), location (which folder), and permission (which permission) to data object
    // calls setFolderPermissionAction to API that takes the data object and saves granted permissions

    // returns an array of users on a transaction that may be granted permissions
    // each object in that array represents a user and the permissions they currently have/don't have
    // iterates over the permissionDetail array set in state from the setPermissionData function to get user data
    let removedList = this.state.permissionDetail.map(function(item) {
      delete item.firstname;
      delete item.lastname;
      delete item.role;
      return item;
    });
    // console.log('removedList: ', removedList);

    var data = {
      transactionId: this.props.transactionId,
      location: this.state.folderName.toString(),
      permission: removedList,
    };
    this.props.setFolderPermissionAction(data).then((res) => {
      // console.log('data: ', data);
      if (res.status === code.OK) {
        this.setPermissionModal();
      }
    });
  }

  /**
   * @desc handle check/uncheck scenario for multiple selection
   * @param {*} name
   * @param {*} val
   */
  setMultiplePermission(name, val) {
    if (val.target.checked) {
      this.setState((prevState) => ({
        folderNameList: [...prevState.folderNameList, name],
      }));
    } else {
      if (this.state.folderNameList.includes(name)) {
        var index = this.state.folderNameList.indexOf(name);
        this.state.folderNameList.splice(index, 1);
      }
    }
    //set checked status folder wise
    var folders = [];
    this.state.folders.filter((foldersList) => {
      if (foldersList.location === name) {
        foldersList.isChecked = val.target.checked;
      }
      folders.push(foldersList);
    });
    this.setState({ folders });

    var checkStatus = [];
    this.state.folders.map((folder) => {
      checkStatus.push(folder.isChecked);
    });
    // for check and uncheck selectAll checkbox
    if (checkStatus.includes(false)) {
      this.state.selectAll = false;
    } else {
      this.state.selectAll = true;
    }
  }

  handleSelectAll(e) {
    let folders = this.state.folders;

    if (e.target.checked) {
      folders.map((item) => {
        item.isChecked = true;
        this.setState((prevState) => ({
          folderNameList: [...prevState.folderNameList, item.location],
        }));
      });
    } else {
      folders.map((item) => {
        item.isChecked = false;
        this.setState({
          folderNameList: [],
        });
      });
    }
    this.setState({ selectAll: !this.state.selectAll });
  }
  render() {
    return (
      <>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <div className="document-page">
          <Row className="ml-0 mr-0 page-head-row page-head-row-inner align-items-center mt-10">
            <Col className="doc-name">
              <h4 className="font-18">Documents</h4>
            </Col>
            <Col className="doc-search">
              <div className="icon-wrapper">
                <Form.Control
                  type="text"
                  className="form-control-head"
                  placeholder="Search by document/folder name"
                  value={this.state.searchParam}
                  onChange={(e) => {
                    this.searchDocumentByName(e.target.value);
                  }}
                />
                <span className="form-control-icn">
                  <Search />
                </span>
              </div>
            </Col>
            <Col align="right" className="doc-black" />
          </Row>

          <div className="container-custom admin-content-area">
            <div className="doc-row pt-2">
              <div className="doc-col">
                <Row className="mx-0 py-1 align-items-center">
                  {this.props.transactionData.status === "COMPLETED" ||
                  (this.state.userType === message.VENDOR &&
                    this.state.userRole === message.Artist) ||
                  this.state.userType === message.BUYER ||
                  this.state.folders.length === 0 ? (
                    ""
                  ) : (
                    <Col className="col-auto pr-0">
                      <input
                        type="checkbox"
                        checked={this.state.selectAll}
                        onChange={(e) => {
                          this.handleSelectAll(e);
                        }}
                      />
                    </Col>
                  )}
                  <Col>
                    <h4 className="font-16 m-0">Document Folder</h4>
                  </Col>

                  <Col align="right" className="col-auto pl-0 pr-1">
                    {this.state.folderNameList.length == 0 ? (
                      this.props.transactionData.status === "COMPLETED" ||
                      (this.state.userType === message.VENDOR &&
                        this.state.userRole === message.Artist) ||
                      this.state.userType === message.BUYER ||
                      this.state.userRole === message.BUYER ? (
                        ""
                      ) : (
                        <Button
                          variant="primary"
                          size="xs"
                          className="btn-outlined btn-blue-light h-auto px-2 font-14"
                          onClick={() => {
                            // if (localStorage.getItem("isActive") === "false") {
                            //   toastMessage(
                            //     code.ERROR,
                            //     "Your subscription is not active, Please activate to continue."
                            //   );
                            // } else {
                            //   this.setModalOpen();
                            // }

                            this.setModalOpen();
                          }}
                        >
                          + New Folder
                        </Button>
                      )
                    ) : (
                      <Button
                        variant="primary"
                        size="xs"
                        className="btn-outlined btn-blue-light h-auto px-2 font-14"
                        onClick={() => {
                          this.setState({
                            showPermissionModal: true,
                            folderName: this.state.folderNameList,
                          });
                          this.getFolderPermission(this.state.folderNameList);
                        }}
                      >
                        Manage Permissions
                      </Button>
                    )}
                  </Col>
                </Row>

                <div className="folder-list-wrapper">
                  <div className="folder-list folder">
                    {this.state.folders.map((folders) => {
                      if (
                        folders.location === "Transaction Docs" &&
                        folders.canView
                      ) {
                        return (
                          <Row
                            className={
                              "mx-0 align-items-center folder-single" +
                              (this.state.selectedFolderName ==
                              +"Transaction Docs"
                                ? " active"
                                : "")
                            }
                            onClick={() => {
                              this.selectFolder("Transaction Docs");
                              this.setState({
                                canAddDoc: folders.canAdd,
                                canArchive: folders.canDelete,
                                canMoveDoc: folders.canMove,
                              });
                            }}
                            key={"Transaction Docs"}
                          >
                            {this.props.transactionData.status ===
                              "COMPLETED" ||
                            (this.state.userType === message.VENDOR &&
                              this.state.userRole === message.Artist) ||
                            this.state.userType === message.BUYER ? (
                              ""
                            ) : (
                              <Col className="col-auto pr-0">
                                <input
                                  type="checkbox"
                                  checked={folders.isChecked}
                                  onChange={(e) => {
                                    this.setMultiplePermission(
                                      "Transaction Docs",
                                      e
                                    );
                                  }}
                                />
                              </Col>
                            )}
                            <Col className="col-auto pr-0">
                              <img
                                src={folderIcon}
                                alt="folder"
                                style={{ height: "30px", width: "30px" }}
                              />
                            </Col>
                            <Col>
                              <h4 className="color-black font-16 mb-0">
                                Transaction Docs <em>(default folder)</em>
                              </h4>
                            </Col>
                            {(this.props.transactionData.status !==
                              "COMPLETED" &&
                              this.state.userType !== message.BUYER) ||
                              this.state.userType === message.ACCTOWNER ||
                              (this.state.userType === message.VENDOR &&
                                this.state.userRole === message.Artist) || (
                                <Col className="col-auto px-0">
                                  <Dropdown
                                    alignRight
                                    className="dropdown-action"
                                  >
                                    <Dropdown.Toggle
                                      variant="transparent"
                                      id="dropdown-folder2"
                                      className="p-0"
                                    >
                                      <MoreVert />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() => {
                                          this.setState({
                                            showPermissionModal: true,
                                            folderName: "Transaction Docs",
                                          });
                                          this.getFolderPermission(
                                            "Transaction Docs"
                                          );
                                        }}
                                      >
                                        Permissions
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </Col>
                              )}
                          </Row>
                        );
                      }
                    })}

                    {this.state.folders
                      .filter((e) => {
                        var found = false;
                        e.documents.map((f) => {
                          if (!f.isDelete) {
                            found = true;
                          }
                        });
                        return found;
                      })
                      .map((folders) => {
                        if (folders.location != "Transaction Docs") {
                          return (
                            <Row
                              className={
                                "mx-0 align-items-center folder-single" +
                                (this.state.selectedFolderName ===
                                folders.location
                                  ? " active"
                                  : "")
                              }
                              onClick={() => {
                                this.setState({
                                  canAddDoc: folders.canAdd,
                                  canArchive: folders.canDelete,
                                  canMoveDoc: folders.canMove,
                                });
                                this.selectFolder(folders.location);
                              }}
                              key={folders.location}
                            >
                              {this.props.transactionData.status ===
                                "COMPLETED" ||
                              (this.state.userType === message.VENDOR &&
                                this.state.userRole === message.Artist) ||
                              this.state.userType === message.BUYER ? (
                                ""
                              ) : (
                                <Col className="col-auto pr-0">
                                  <input
                                    type="checkbox"
                                    checked={folders.isChecked}
                                    onChange={(e) => {
                                      this.setMultiplePermission(
                                        folders.location,
                                        e
                                      );
                                    }}
                                  />
                                </Col>
                              )}
                              <Col className="col-auto pr-0">
                                <img
                                  src={folderIcon}
                                  alt="folder"
                                  style={{ height: "30px", width: "30px" }}
                                />
                              </Col>
                              <Col>
                                <h4 className="color-black font-16 mb-0">
                                  {folders.location}
                                </h4>
                              </Col>
                              {this.props.transactionData.status !==
                                "COMPLETED" && (
                                <Col className="col-auto px-0">
                                  <Dropdown
                                    alignRight
                                    className="dropdown-action"
                                  >
                                    <Dropdown.Toggle
                                      variant="transparent"
                                      id="dropdown-folder2"
                                      className="p-0"
                                    >
                                      <MoreVert />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() => {
                                          this.setModalOpen(folders.location);
                                        }}
                                      >
                                        Rename
                                      </Dropdown.Item>

                                      {folders.canDelete && (
                                        <Dropdown.Item
                                          onClick={() => {
                                            this.setState({
                                              archiveName: folders.location,
                                              showArchiveModal: true,
                                            });
                                          }}
                                          className="color-dark-orange-3"
                                        >
                                          Archive
                                        </Dropdown.Item>
                                      )}

                                      {this.state.userType !== message.BUYER ||
                                        this.state.userType ===
                                          message.ACCTOWNER ||
                                        (this.state.userType ===
                                          message.VENDOR &&
                                          this.state.userRole ===
                                            message.Artist) || (
                                          <Dropdown.Item
                                            onClick={() => {
                                              this.setState({
                                                showPermissionModal: true,
                                                folderName: folders.location,
                                              });
                                              this.getFolderPermission(
                                                folders.location
                                              );
                                            }}
                                          >
                                            Permissions
                                          </Dropdown.Item>
                                        )}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </Col>
                              )}
                            </Row>
                          );
                        } else {
                          return "";
                        }
                      })}
                  </div>

                  {(this.state.userType === message.VENDOR &&
                    this.state.userRole === message.Artist) ||
                  this.state.userType === message.BUYER ? (
                    ""
                  ) : (
                    <div className="folder-list archieve">
                      <Row
                        className="mx-0 align-items-center folder-single archieve-acc-title"
                        onClick={() => this.showArchieve()}
                        aria-controls="example-collapse-text"
                        aria-expanded={this.state.showArchieve}
                      >
                        <Col className="col-auto pr-0">
                          <Archive className="color-grey-1" />
                        </Col>
                        <Col>
                          <h4 className="font-16 mb-0 font-400">Archive</h4>
                        </Col>
                        <Col className="col-auto px-0">
                          <KeyboardArrowRight className="KeyboardArrowRight" />
                          <KeyboardArrowDown className="KeyboardArrowDown" />
                        </Col>
                      </Row>

                      {/* archieve folders toggle */}
                      <Collapse in={this.state.showArchieve}>
                        <div className="folder-list folder">
                          <Row
                            className={
                              "mx-0 align-items-center folder-single" +
                              (this.state.selectedFolderName === "Archived Docs"
                                ? " active"
                                : "")
                            }
                            onClick={() => {
                              this.selectFolder("Archived Docs", true);
                            }}
                            key={"Archived Docs"}
                          >
                            <Col className="col-auto pr-0">
                              <img
                                src={folderIcon}
                                alt="folder"
                                style={{ height: "30px", width: "30px" }}
                              />
                            </Col>
                            <Col>
                              <h4 className="color-black font-16 mb-0">
                                Archived Docs
                              </h4>
                            </Col>
                          </Row>
                          {this.state.archiveFolders
                            .filter((e) => {
                              var found = false;
                              e.documents.map((f) => {
                                if (f.isDelete && !f.isFolderEmpty) {
                                  found = true;
                                }
                              });
                              return found;
                            })
                            .map((folders) => {
                              if (
                                folders.location != "Transaction Docs" &&
                                folders.isDelete &&
                                !folders.isFolderEmpty
                              ) {
                                return (
                                  <Row
                                    className={
                                      "mx-0 align-items-center folder-single" +
                                      (this.state.selectedFolderName ===
                                      folders.location
                                        ? " active"
                                        : "")
                                    }
                                    onClick={() => {
                                      this.setState({
                                        canAddDoc: folders.canAdd,
                                        canArchive: folders.canDelete,
                                        canMove: folders.canMove,
                                      });
                                      this.selectFolder(folders.location, true);
                                    }}
                                    key={folders.location}
                                  >
                                    <Col className="col-auto pr-0">
                                      <img
                                        src={folderIcon}
                                        alt="folder"
                                        style={{
                                          height: "30px",
                                          width: "30px",
                                        }}
                                      />
                                    </Col>
                                    <Col>
                                      <h4 className="color-black font-16 mb-0">
                                        {folders.location}
                                      </h4>
                                    </Col>
                                  </Row>
                                );
                              } else {
                                return "";
                              }
                            })}
                        </div>
                      </Collapse>
                    </div>
                  )}
                </div>
              </div>

              {/* folder detail */}
              <div className="doc-col col-full">
                <DocumentsDetail
                  folderName={this.state.selectedFolderName}
                  transactionId={this.props.transactionId || ""}
                  documents={this.state.documents}
                  uploadNewDocument={(files) => {
                    this.uploadNewDocument(files);
                  }}
                  archiveDocument={(res) => {
                    this.refreshDocuments(res);
                  }}
                  folderId={this.state.folderId}
                  hideNewDocument={this.state.hideNewDocument}
                  transactionData={this.props.transactionData}
                  canAddDoc={this.state.canAddDoc}
                  canArchive={this.state.canArchive}
                  canMove={this.state.canMoveDoc}
                />
              </div>
            </div>
          </div>
          {/* folder permission modal  */}
          <Modal
            className="doc_share_options"
            show={this.state.showPermissionModal}
            onHide={() => this.setPermissionModal()}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Sharing options for {this.state.folderName.toString()}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="folder-list folder">
                <div className="rsp-table">
                  <div className="rsp-row rsp-header">
                    <div className="rsp-cell">Share with</div>
                    <div className="rsp-cell">Role</div>
                    <div className="rsp-cell center">View</div>
                    <div className="rsp-cell center">Add</div>
                    <div className="rsp-cell center">Archive</div>
                    <div className="rsp-cell center">Move</div>
                  </div>
                  {!!this.state.permissionDetail
                    ? this.state.permissionDetail.map((permissionDetail) => {
                        return (
                          <div class="rsp-row">
                            <div class="rsp-cell" data-title="Share with">
                              {permissionDetail.firstname + (permissionDetail.lastname ? 
                                " " +
                                permissionDetail.lastname : "" )}
                            </div>
                            <div class="rsp-cell" data-title="Role">
                              {!!permissionDetail.role
                                ? permissionDetail.role
                                : ""}
                            </div>
                            <div class="rsp-cell center" data-title="View">
                              <label class="check-label">
                                <Form.Control
                                  type="checkbox"
                                  disabled={this.state.viewDisabled}
                                  checked={permissionDetail.canView}
                                  onChange={(e) => {
                                    this.setPermissionData(
                                      permissionDetail.userId,
                                      "view",
                                      e
                                    );
                                  }}
                                />
                                <span class="checkmark" />
                              </label>
                            </div>
                            <div class="rsp-cell center" data-title="Add">
                              <label class="check-label">
                                <Form.Control
                                  type="checkbox"
                                  checked={permissionDetail.canAdd}
                                  onChange={(e) => {
                                    if (
                                      e.target.checked &&
                                      permissionDetail.canView == false
                                    ) {
                                      this.setState({ viewDisabled: true });
                                      permissionDetail.canView = true;
                                    } else if (
                                      !permissionDetail.canArchive &&
                                      !permissionDetail.canMove
                                    ) {
                                      this.setState({ viewDisabled: false });
                                    }
                                    this.setPermissionData(
                                      permissionDetail.userId,
                                      "add",
                                      e
                                    );
                                  }}
                                />
                                <span class="checkmark" />
                              </label>
                            </div>
                            <div
                              class="rsp-cell center"
                              data-title="Remove / Archive"
                            >
                              <label class="check-label">
                                <Form.Control
                                  type="checkbox"
                                  checked={permissionDetail.canDelete}
                                  onChange={(e) => {
                                    if (
                                      e.target.checked &&
                                      permissionDetail.canView == false
                                    ) {
                                      this.setState({ viewDisabled: true });
                                      permissionDetail.canView = true;
                                    } else if (
                                      !permissionDetail.canAdd &&
                                      !permissionDetail.canMove
                                    ) {
                                      this.setState({ viewDisabled: false });
                                    }
                                    this.setPermissionData(
                                      permissionDetail.userId,
                                      "delete",
                                      e
                                    );
                                  }}
                                />
                                <span class="checkmark" />
                              </label>
                            </div>
                            <div class="rsp-cell center" data-title="Move">
                              <label class="check-label">
                                <Form.Control
                                  type="checkbox"
                                  checked={permissionDetail.canMove}
                                  onChange={(e) => {
                                    if (
                                      e.target.checked &&
                                      permissionDetail.canView == false
                                    ) {
                                      this.setState({ viewDisabled: true });
                                      permissionDetail.canView = true;
                                    } else if (
                                      !permissionDetail.canArchive &&
                                      !permissionDetail.canAdd
                                    ) {
                                      this.setState({ viewDisabled: false });
                                    }
                                    this.setPermissionData(
                                      permissionDetail.userId,
                                      "move",
                                      e
                                    );
                                  }}
                                />
                                <span class="checkmark" />
                              </label>
                            </div>
                          </div>
                        );
                      })
                    : ""}
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="primary"
                type="submit"
                size="sm"
                className="btn-blue w-140"
                onClick={() => {
                  this.setUserPermission();
                }}
              >
                Okay
              </Button>
              <Button
                variant="secondary"
                type="reset"
                size="sm"
                className="btn-blue w-140"
                onClick={() => {
                  this.setPermissionModal();
                }}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.show}
            onHide={() => this.setModalOpen()}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                {this.state.renameFolder ? "Rename Folder" : "Create Folder"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form className="form-sm form-admin">
                <Form.Group controlId="" className="mb-3 email-case">
                  <label>Folder Name</label>
                  <Form.Control
                    type="text"
                    className={"field_ucfirst"}
                    value={this.state.folderName}
                    onChange={(e) => {
                      this.setState({
                        folderName: e.target.value,
                        folderExists: false,
                      });
                    }}
                  />

                  {this.state.folderExists && (
                    <Form.Text className="text-danger">
                      A folder with that name already exists.
                    </Form.Text>
                  )}
                </Form.Group>
                <Button
                  type="button"
                  variant="primary"
                  size="sm"
                  disabled={this.state.folderName === "" ? true : false}
                  className="btn-blue w-140"
                  onClick={() => {
                    this.createNewFolder(this.state.folderName);
                  }}
                >
                  {this.state.renameFolder ? "Rename" : "Create"}
                </Button>
              </Form>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.OpenDocumentDetail}
            onHide={() => this.OpenDocumentDetail()}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med modal-view-page"
          >
            <Modal.Header closeButton />
            <Modal.Body>
              <DocumentsDetail
                folderName={this.state.selectedFolderName}
                folderId={this.state.folderId}
                transactionId={this.props.transactionId || ""}
                documents={this.state.documents}
                uploadNewDocument={(files) => {
                  this.uploadNewDocument(files);
                }}
                archiveDocument={(res) => {
                  this.refreshDocuments(res);
                }}
                hideNewDocument={this.state.hideNewDocument}
                transactionData={this.props.transactionData}
                canAddDoc={this.state.canAddDoc}
                canMove={this.state.canMoveDoc}
              />
            </Modal.Body>
          </Modal>
          {/**archive confirmation modal */}
          <Modal
            show={this.state.showArchiveModal}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med modal-400 modal-delete"
            centered
            backdrop={false}
          >
            <Modal.Body className="pb-0 text-center">
              <HelpOutline />
              <p>Are you sure you want to archive this folder?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                className="btn-blue btn-outlined w-140"
                onClick={() => {
                  this.setState({ showArchiveModal: false, archiveName: "" });
                }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                className="btn-blue w-140"
                onClick={() => {
                  this.archiveFolder(this.state.archiveName);
                }}
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    docs: state.reducer.docs,
    totalDocs: state.reducer.totalDocs,
  };
};

export default connect(
  mapStateToProps,
  {
    listDocAction,
    addDocAction,
    updateDocAction,
    uploadDocumentAction,
    removeDocAction,
    getFolderPermissionAction,
    setFolderPermissionAction,
  }
)(Documents);
